import {toast} from "react-toastify";
import React from "react";
import {HugeiconsIcon} from "@hugeicons/react";
import {
    AlertCircleIcon,
    CallDisabledIcon,
    CallEnd01Icon,
    CallEnd03Icon,
    CallIncoming01Icon,
    CallMissed01Icon,
    CallingIcon,
    CheckIcon,
    MessageCircleCheckIcon,
    MessageCircleIcon,
    MessageCircleXIcon,
    PhoneForwardedIcon,
} from "@hugeicons/core-free-icons";
import {green, red, orange, lightBlue, blue, grey} from "@mui/material/colors";
const TRIGGER_RE = /\{\{\s*([\w.$-]*)$/;
export const copyToClipboard = async (data) => {
    try {
        await navigator.clipboard.writeText(data);
    } catch (error) {
        toast.error("Error copying URL")
    }
}

export const mapToUrl = (path, baseUrl = "") => {
    return new URL(path, baseUrl).toString();
}

export const getConversationIcon = (status) => {
    return {
        "ACTIVE": <HugeiconsIcon icon={CallingIcon} size={21} color={green[400]} className={"phone-shake"}/>,
        "FINISHED": <HugeiconsIcon icon={CallEnd01Icon} size={21} color={"#1976d2"}/>,
        "SUCCESS": <HugeiconsIcon icon={CheckIcon} size={21} color={green[700]}/>,
        "REDIRECTED": <HugeiconsIcon icon={PhoneForwardedIcon} size={21} color={orange[700]}/>,
        "FAILED": <HugeiconsIcon icon={CallEnd03Icon} size={21} color={"rgb(211, 47, 47)"}/>,
        "HANDOVER": <HugeiconsIcon icon={PhoneForwardedIcon} size={21} color={"#1976d2"}/>,
        "HANGUP": <HugeiconsIcon icon={CallDisabledIcon} size={21} color={"#1976d2"}/>,
        "MISSED_CALL": <HugeiconsIcon icon={CallMissed01Icon} size={21} color={"#d32f2f"} className={"phone-shake"}/>,
        "AGENT_CALL_INITIATED": <HugeiconsIcon icon={CallIncoming01Icon} size={21} color={green[500]}/>,
        "USER_NOT_TALKING": <HugeiconsIcon icon={AlertCircleIcon} size={21} color={orange[500]}/>,
    }[status]
}
export const getChatIcon = (status) => {
    switch (status) {
        case "ACTIVE":
            return <HugeiconsIcon icon={MessageCircleIcon} size={16} color={grey[600]}/>;
        case "FINISHED":
            return <HugeiconsIcon icon={MessageCircleCheckIcon} size={16} color={green[600]}/>;
        case "FAILED":
            return <HugeiconsIcon icon={MessageCircleXIcon} size={16} color={"rgb(211, 47, 47)"}/>
        default:
            return <HugeiconsIcon icon={MessageCircleIcon} size={16} color={grey[400]}/>;
    }
};

export const getBgColorIcon = (status) => {
    return {
        "ACTIVE": green[50],
        "FINISHED": lightBlue[50],
        "SUCCESS": green[100],
        "REDIRECTED": orange[100],
        "FAILED": red[100],
        "HANDOVER": lightBlue[50],
        "HANGUP": blue[100],
        "MISSED_CALL": red[100],
        "AGENT_CALL_INITIATED": green[50],
        "USER_NOT_TALKING": orange[50],
    }[status]
}

export const formatTime = (sec) => {
    const minutes = Math.floor(sec / 60);
    const seconds = Math.floor(sec % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
};

export default function isElectron() {
    return (window && window.process && window.process.type === 'renderer') || (navigator.userAgent.toLowerCase().includes('electron'))
}

export function detectVariableTrigger(text, caret) {
    const match = text.slice(0, caret).match(TRIGGER_RE);
    if (!match) return null;
    return { query: match[1], start: match.index, end: caret };
}
